<template>
  <div>

    <div class="center big-padding">
      Souhaitez-vous désactiver le maitrise <strong>{{user.nom}} {{user.prenom}} </strong> - <strong>{{user.arrondissement_id | allArrondissementName}}</strong> ? <br>Ce compte ne pourra alors plus accéder à l'application.
    </div>

    <div class="buttons">
      <div class="btn btn-primary" v-on:click='confirm()'>
        Désactiver
      </div>

      <div class="btn btn-default" v-on:click="$emit('close')">
        Annuler
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'user',
  ],
  methods: {
    confirm: function () {
      this.$store.dispatch('deactivateUser', this.user)
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// UserDelete.vue?b4461b36